import React from 'react'
import { Box, Typography } from '@mui/material'

import useOrbitFlag from '../../../hooks/useOrbitFlag'

import DemoMenu from './DemoMenu'

function LogInNav() {
  const FlagDemoMenu = useOrbitFlag('demoMenu')

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        height: '5vh',
        width: '95vw',
        borderBottom: '1px solid #FFFFFF'
      }}
    >
      <Box sx={{ display: 'flex', marginBottom: '30px' }}>
        <Typography
          sx={{ fontSize: '1.2em', color: 'white', padding: '0 20px' }}
        >
          Terms
        </Typography>
        <Typography
          sx={{ fontSize: '1.2em', color: 'white', padding: '0 20px' }}
        >
          Privacy
        </Typography>
        <Typography
          sx={{ fontSize: '1.2em', color: 'white', padding: '0 20px' }}
        >
          Security
        </Typography>
        <Typography
          sx={{ fontSize: '1.2em', color: 'white', padding: '0 20px' }}
        >
          Get In Touch
        </Typography>
        {FlagDemoMenu && (
          <Box>
            <DemoMenu />
          </Box>
        )}
      </Box>
    </Box>
  )
}

export default LogInNav
